import { forwardRef, useRef } from 'react';

import { useWebViewPlugin } from './useWebViewPlugin';

export type GameRunnerProps = { title: string; src: string; clientID?: string };

// eslint-disable-next-line
export const GameRunner = forwardRef<HTMLIFrameElement, GameRunnerProps>(({ title, src, clientID }, ref) => {
    const webviewRef = useRef(null);
    useWebViewPlugin(ref || webviewRef, src, clientID);

    return (
        <iframe
            style={{ border: 'none', height: '100%', width: '100%', margin: 0, padding: 0, overflow: 'hidden' }}
            ref={ref || webviewRef}
            title={title}
            src={src}
            allow="gyroscope; accelerometer; magnetometer; autoplay; microphone"
        />
    );
});
